import React from 'react';
import styled from 'styled-components';

type MinusIconProps = Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
  color?: string;
  scale?: number;
};

const StyledSvg = styled.svg.withConfig({
  shouldForwardProp: (prop) => prop !== 'scale',
})<{ scale?: number }>`
  color: var(--way-colors-svgColor);
  height: ${({ scale = 1 }) => 16 * scale}px;
  width: ${({ scale = 1 }) => 17 * scale}px;
`;

const MinusIcon = ({ color, scale = 1, ...props }: MinusIconProps) => (
  <StyledSvg
    fill="none"
    scale={scale}
    style={{ color }}
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.83398 7.3335H13.1673V8.66683H3.83398V7.3335Z"
      style={{
        fill: 'currentColor',
        stroke: 'none',
      }}
    />
  </StyledSvg>
);

MinusIcon.displayName = 'MinusIcon';

export default MinusIcon;
